import MarkdownDisplay from '../MarkdownDisplay';
import { isHtml } from '../helpers/markdown';

import './styles.css';

// Re-export isHtml for convenience
export { isHtml };

/**
 * Component that renders either HTML or Markdown content
 * automatically detecting the format.
 *
 * Use this for displaying content that may be in either format
 * (useful during migration from HTML to Markdown).
 */
const MarkdownOrHtmlDisplay = ({ content, className = '' }) => {
	if (!content) {
		return null;
	}

	if (isHtml(content)) {
		// Legacy HTML content - render with dangerouslySetInnerHTML
		return (
			<div
				className={`html-display prose prose-sm max-w-none ${className}`}
				dangerouslySetInnerHTML={{ __html: content }}
			/>
		);
	}

	// Markdown content - use MarkdownDisplay
	return <MarkdownDisplay content={content} className={className} />;
};

export default MarkdownOrHtmlDisplay;
